import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_url } from "../config/config";

const PaymentsList = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [date, setDate] = useState("");

  const admin_token = localStorage.getItem("admin_token");

  const fetchPayments = async (search = "", date = "", branch = "", status = "") => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${api_url}/api/payments?search=${search}&date=${date}&branch_id=${branch}&status=${status}`,
        {
          headers: {
            Authorization: `Bearer ${admin_token}`,
          },
        }
      );
      setPayments(response.data.data || []);
    } catch (error) {
      console.error("Error fetching payments:", error);
      alert("Failed to fetch payments");
    } finally {
      setLoading(false);
    }
  };

  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${api_url}/branches?search=${searchTerm}`);

      const rawBranches = response.data.results || [];

      const uniqueBranches = [
        ...new Map(
          rawBranches.map((branch) => [branch.branch_id, branch])
        ).values(),
      ];

      setBranches(uniqueBranches);
      console.log("Unique Branches:", uniqueBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };


    const exportToCSV = () => {
      if (payments.length === 0) {
        alert("No data available to export");
        return;
      }

      const headers = [
        "Payment Id",
        "Order Id",
        "User Name",
        "Amount",
        "Payment Method",
        "Status",
        "Created At",
      ];

      const rows = payments.map((payment) => [
        payment.razorpay_payment_id || "N/A",
        payment.order_id || "N/A",
        payment.order?.user?.name || "N/A",
        payment.amount || "N/A",
        payment.method || "N/A",
        payment.status || "N/A",
        new Date(payment.created_at).toLocaleString(),
      ]);

      const csvContent = [
        headers.join(","), 
        ...rows.map((row) => row.join(",")),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `payments_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };



  useEffect(() => {
    fetchPayments();
    fetchBranches();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchPayments(searchTerm, date, selectedBranch, selectedStatus);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, date, selectedBranch, selectedStatus]);

    return (
        <div className="flex flex-col">
        <div className="flex-grow overflow-auto">
            <h2 className="text-2xl font-bold mb-4 mt-7">Payments List</h2>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="w-full flex items-center gap-5 mb-4">
                    <input
                        type="text"
                        className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
                        placeholder="search by payment id, order id, user name"
                        title="search by payment id, order id, user name"
                        value={searchTerm}
                        onChange={e => {
                            setSearchTerm(e.target.value);
                        }}
                    />
                    <input
                        type="date"
                        className="border rounded-xl border-slate-700 p-2 w-[200px] px-3"
                        placeholder="search by payment id, order id, user name"
                        value={date}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={e => {
                            setDate(e.target.value);
                        }}
                    />
                  <select
                    className="p-2 border border-gray-300 rounded max-w-[200px]"
                    value={selectedBranch}
                    onChange={(e) => {
                      setSelectedBranch(e.target.value);
                    }}
                  >
                    <option value="">
                      Select Branch
                    </option>
                    {branches.map((branch) => (
                      <option key={branch.branch_id} value={branch.branch_id}>
                        {branch.area}
                      </option>
                    ))}
                  </select>
                  <select
                    className="p-2 border border-gray-300 rounded max-w-[200px]"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  >
                    <option value="">
                      Select Status
                    </option>
                    <option value="captured">Captured</option>
                    <option value="failed">Failed</option>
                  </select>
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={() => {
                      setSearchTerm("");
                      setDate("");
                      setSelectedBranch("");
                      setSelectedStatus("");
                      fetchPayments("", "", "", "");
                    }}
                  >
                    Clear Filters 
                  </button>
                  <button
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                    onClick={exportToCSV}
                  >
                    Export CSV
                  </button>
                </div>
                <table className="table-auto w-full text-sm text-left">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-6 py-3">Payment Id</th>
                            <th className="px-6 py-3">Order id</th>
                            <th className="px-6 py-3">User Name</th>
                            <th className="px-6 py-3">Amount</th>
                            <th className="px-6 py-3">Payment Method</th>
                            <th className="px-6 py-3">Status</th>
                            <th className="px-6 py-3">Created At</th>
                        </tr>
                    </thead>
                    <tbody className="overflow-y-auto max-h-[400px]">
                        {payments.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="text-center py-8 text-gray-500">
                                    No payments found matching your search.
                                </td>
                            </tr>
                        ) : (
                            payments.map((payment) => (
                                <tr key={payment.id} className="hover:bg-gray-100">
                                    <td className="px-6 py-3">{payment.razorpay_payment_id || "N/A"}</td>
                                    <td className="px-6 py-3">{payment.order_id || "N/A"}</td>
                                    <td className="px-6 py-3">{payment.order.user.name || "N/A"}</td>
                                    <td className="px-6 py-3">{payment.amount || "N/A"}</td>
                                    <td className="px-6 py-3">{payment.method || "N/A"}</td>
                                    <td className="px-6 py-3">{payment.status || "N/A"}</td>
                                    {/* <td className="px-6 py-3">
                                      <span
                                        className={`px-2 py-1 rounded-full text-xs font-medium 
                                          ${payment.status === "captured"
                                            ? "bg-green-400 text-white-700 border border-green-400"
                                            : payment.status === "failed"
                                            ? "bg-red-400 text-white-700 border border-red-400"
                                            : "bg-gray-400 text-gray-700 border border-gray-400"
                                          }`}
                                      >
                                        {payment.status || "N/A"}
                                      </span>
                                    </td> */}
                                    <td className="px-6 py-3">
                                       {new Date(payment.created_at).toLocaleString()}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                {/* {renderPagination()} */}
            </div>
        </div>
    </div> 
    );
};

export default PaymentsList;
